import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import N_tick from "../../../../src/assets/images/N_tick.png";
import N_wws_warehousing from "../../../assets/images/warehousing_icon.png";
import N_wws_fumigation from "../../../assets/images/fumignation_icon.png";
import N_wws_Procurement from "../../../assets/images/feild_icon.png";
import port_icon from "../../../assets/images/port_icon.png";
import test_icon from "../../../assets/images/test_icon.png";
import N_wws_Export from "../../../assets/images/export_assist_icon.png";
import ServiceContact from "../../../_Pages/_webapp/OurServises/ServiceContact";
import Subscribe from "../../../_Pages/_webapp/_mainHome/Subscribe";
import WebFooter from "../../../_components/_webapp/Footer/WebFooter";

class WweInternationalBuyer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "en",
    };
  }
  componentDidMount() {
    let lang = localStorage.getItem("lang");
    this.setState({
      lang: lang,
    });
  }
  render() {
    const metaTags = document.getElementsByTagName("meta");
    for (const tag of metaTags)
      if (tag.name === "description")
        tag.content =
          "Arya serves international buyers for warehousing, fumigation, quality testing, and assaying and also helps in export assistance. Contact us for more information.";

    return (
      <React.Fragment>
        <SetHeader active={"story"} history={this.props.history}></SetHeader>
        <Helmet>
          <title>Who we Serve | International Buyers | Arya</title>
          <meta
            name="keywords"
            content="Warehouse near me, paddy warehouse, Maize Warehouse, Sugar warehouse, Wheat warehouse, Soyabean warehouse, Rice warehouse, Cotton warehouse, List your warehouse, Buy sell paddy online, Buy sell maize online, Buy sell pulses online, Buy sell spices online, Get loan on agri products, Get loan on agri commodities, Get finance on your commodities, paddy stock near me, maize Stock near me, Wheat stock near me, Bajra Stock near me, Jowar stock near me, Sugar stock near me, Soybean Stock near me, Cotton stock near me, Rice stock near me"
          />
        </Helmet>
        <section className="Whoweservebanner IB_Banner">
          <Container>
            <Row>
              <Col>
                <div className="wws_banner_portion">
                  <div className="wws_banner_heading">
                    {/* <h1><MultiLanguageTranslation title="9600+ Warehouses Across 800+ Locations" /></h1> */}
                    <h1>
                      {localStorage.getItem("warehouseCount")
                        ? localStorage.getItem("warehouseCount") + "+"
                        : "9600+"}
                      <MultiLanguageTranslation title=" Warehouses Across " />
                      {localStorage.getItem("districtCount")
                        ? localStorage.getItem("districtCount") + "+"
                        : "800+"}
                      <MultiLanguageTranslation title=" Locations" />
                    </h1>
                  </div>
                  <div className="wws_banner_heading_content">
                    <a href="/WhoWeServeFPO">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Farmer & FPO" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Processor">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Processors" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Agri_corporation">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Agri Corporations" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/Financial">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Financial Institutions" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/InternationalBuyer">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="International Buyers" />
                      </span>
                    </a>
                    <a href="/WhoWeServe/DevelopmentActors">
                      <img alt="" src={N_tick} />
                      <span>
                        <MultiLanguageTranslation title="Development Actors" />
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="NA_customBreadcumb">
                <Link onClick={() => this.props.history.push("/")}>
                  <MultiLanguageTranslation title="Arya.ag" />
                </Link>{" "}
                <span>→</span>{" "}
                <Link onClick={() => this.props.history.push("/WhoWeServe")}>
                  <MultiLanguageTranslation title="Who We Serve" />
                </Link>{" "}
                <span>→</span>
                <span className="breadcrumb_active">
                  <MultiLanguageTranslation title="International Buyers" />
                </span>
              </div>
            </div>
          </div>
        </div>

        <section className="N_wws">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="N_wws_heading">
                  <h2>
                    <MultiLanguageTranslation title="International Buyers" />
                  </h2>
                </div>
                <div className="wws_desc">
                  <p>
                    <MultiLanguageTranslation title="international_page_title_India_is_a_powerhouse" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="N_wws_offer_por">
          <Container>
            <Row>
              <Col>
                <div className="N_wws_offer">
                  <div className="N_wws_offer_heading">
                    <h4>
                      <MultiLanguageTranslation title="Our Offerings" />
                    </h4>
                  </div>
                  <div className="N_wws_offer_content-sec">
                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_warehousing} />
                      <h5>
                        <MultiLanguageTranslation title="Warehousing" />
                      </h5>
                    </div>

                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_fumigation} />
                      <h5>
                        <MultiLanguageTranslation title="Fumigation" />
                      </h5>
                    </div>
                    <div className="N_wws_offer_content">
                      <img alt="" src={test_icon} />
                      <h5>
                        <MultiLanguageTranslation title="Quality Testing & Assaying" />
                      </h5>
                    </div>
                    <div className="N_wws_offer_content">
                      <img alt="" src={port_icon} />
                      <h5>
                        <MultiLanguageTranslation title="Port & Rake Handling & Stockpoint Audits" />
                      </h5>
                    </div>
                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Procurement} />
                      <h5>
                        <MultiLanguageTranslation title="Quality Procurement Assistance & Monitoring" />
                      </h5>
                    </div>
                    <div className="N_wws_offer_content">
                      <img alt="" src={N_wws_Export} />
                      <h5>
                        <MultiLanguageTranslation title="Export Assistance" />
                      </h5>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <ServiceContact />
        <section className="formContent">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>
                  <MultiLanguageTranslation title="ARYA - Connecting International Buyers for Agricultural Products with Farmers" />
                </h1>

                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="international_buyer_p1" />
                  ) : (
                    <>
                      Our farmers are the backbone of our country. They work day
                      and night so that our plates can remain full. But the
                      condition of the farmers of the country is not very good.
                      They have to fight for their survival every day. We
                      understand the importance of the farmers and help them
                      connect with the international buyers so that they can get
                      the right price for the crops they have grown. ARYA is
                      known as the best companion of the farmers because of the
                      help it provides to them with{" "}
                      <b>international buyers for agricultural products </b>
                    </>
                  )}
                </p>

                <h2>
                  <MultiLanguageTranslation title="We work in hand with the farmers for their benefits" />
                </h2>
                <p>
                  {this.state.lang === "hindi" ? (
                    <MultiLanguageTranslation title="international_buyer_p2" />
                  ) : (
                    <>
                      In terms of agriculture, India is a key player. Because of
                      its different agro-climatic zones, the nation can
                      cultivate a broad variety of crops. For foreign buyers,
                      the country's quality and cost of these commodities make
                      it a desirable destination. ARYA has a particular
                      advantage in serving overseas consumers wishing to buy
                      from India because of its presence and expertise across
                      the agriculture value chain. We arrange for the right{" "}
                      <b>buyer agriculture products </b> so that the farmers can
                      sell their products and get the right financial help for
                      their next harvest.
                    </>
                  )}
                </p>
                <h3>
                  <MultiLanguageTranslation title="ARYA Welcomes All No Matter Big Or Small" />
                </h3>
                <p>
                  <MultiLanguageTranslation title="international_buyer_p3" />
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="N_stay_update">
          <div className="container">
            <div className="row">
              <Subscribe></Subscribe>
            </div>
          </div>
        </section>
        <WebFooter />
      </React.Fragment>
    );
  }
}
export default WweInternationalBuyer;
